module.exports = __webpack_public_path__ + "img/thumbnail_RedNeckedWallaby_j_normal.0ab6832e.png";